import { CommonMessages } from "../messages/validationMessages"
import * as Yup from 'yup'

export const addPackageSchema = Yup.object().shape({
    packagename: Yup.string().required(CommonMessages.package_name_required),
    packagedescription: Yup.string().required(CommonMessages.package_description_required),
    packageprice: Yup.string().matches(/^\d{0,8}(\.\d{0,2})?$/, 'Enter price.').required(CommonMessages.package_price_required),

})